import React, { useEffect, useState } from 'react';

const PlaceholderTypewriterInput = ({ value, onChange }) => {
  const placeholders = [
    'Search By Student Name',
    'Search By Student Id',
    'Search By Parent Mobile No',
    'Search By Parent Name',
  ];

  const [placeholder, setPlaceholder] = useState('');
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = placeholders[index];

    const timeout = setTimeout(() => {
      if (!deleting && charIndex < current.length) {
        setPlaceholder(current.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      } else if (deleting && charIndex > 0) {
        setPlaceholder(current.substring(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);
      } else if (!deleting && charIndex === current.length) {
        setTimeout(() => setDeleting(true), 1000);
      } else if (deleting && charIndex === 0) {
        setDeleting(false);
        setIndex((prev) => (prev + 1) % placeholders.length);
      }
    }, deleting ? 50 : 100); // speed for typing/deleting

    return () => clearTimeout(timeout);
  }, [charIndex, deleting, index, placeholders]);

  return (
    <input
      type="text"
      placeholder={placeholder }
      value={value}
      onChange={onChange}
      className="input"
      autoComplete="off"
    />
  );
};

export default PlaceholderTypewriterInput;
